<div>
    <p>.:: The Maximum Size allowed for the Posted File is 60 MegaBytes ::.</p>
    <div class="form-group row">
        <div style="display: flex; align-items: center;">
            <input style="display:none" type="file" #file id="localImportId" (click)="file.value=null"   (change)="onFileSelected($event)"
                [accept]="acceptTypes()">
            <input class="form-control fileInputTextControl" type="text" [value]="selectedFileName" readonly> <label
                for="localImportId" class="btn btn-light">Browse</label>
        </div>
    </div>
</div>